import React, { useState, useEffect } from 'react';
import classes from './JobAdmin.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { jobActions } from '../../store/jobSlice';
import { Link } from 'react-router-dom';
let send = false;

const JobAdmin = (props) => {

  const dispatch = useDispatch();
  // const jobList = useSelector(state => state?.job?.items);

  const [company, setCompany] = useState(props.company);
  const [role, setRole] = useState(props.role);
  const [experience, setExperience] = useState(props.experience);
  const [deadline, setDeadline] = useState(props.deadline);
  const [url, setUrl] = useState(props.url);
  const [companyUrl, setCompanyUrl] = useState(props.companyUrl);
  const [logo, setLogo] = useState(props.logoURL);
  const [description, setDescription] = useState(props?.description);
  const [requirements, setRequirements] = useState(props?.requirements);
  const [location, setLocation] = useState(props?.location);
  const [salary, setSalary] = useState(props?.salary);

  const [update, setUpdate] = useState(false);

  const deleteJobHandler = () => {
    dispatch(jobActions.deleteJob(props.id));
  }

  const triggerUpdateHandler = () =>{
    setUpdate(!update);
  }

  const updateJobHandler = (event) => {
    event.preventDefault();

    dispatch(jobActions.updateJob({
      id:props.id,
      role: role,
      company: company,
      experience: experience,
      deadline: deadline,
      url: url,
      companyUrl:companyUrl,
      logo: logo,
      description:description,
      location:location,
      requirements:requirements,
      salary:salary
    }));
    triggerUpdateHandler();
  }

  return (
    <>
      {!update && <div className={classes.job_admin}>
        <div className={classes.left}>
          <h2>Company : {props.company}</h2>
          <h3>Job Role : {props.role}</h3>
          <h3>Experience : {props.experience}</h3>
          <h3>Deadline : {props.deadline}</h3>
          <h3>Application URl : <Link to={props.url}>{props.url}</Link></h3>
          <h3>Company URl : <Link to={props.companyUrl}>{props.companyUrl}</Link></h3>
          {/* <h3>Logo URL : <Link to={props.logoURL}>{props.logoURL}</Link></h3> */}
          <h3>Loaction : {props?.location}</h3>
          <h3>Salary : {props?.salary}</h3>
          {/* <h3>Description : {props?.description}</h3> */}
          {/* <h3>Requirements : {props?.requirements}</h3> */}
        </div>
        <div className={classes.right}>
          <button onClick={triggerUpdateHandler}>Update</button>
          <button onClick={deleteJobHandler}>Delete</button>
        </div>
      </div>}

      {update &&

        <form onSubmit={updateJobHandler} className={classes.job_admin}>
          <div className={classes.left}>
            <h2>Company : <input value={company} onChange={(event)=>{setCompany(event.target.value)}}></input></h2>
            <h3>Job Role : <input value={role} onChange={(event)=>{setRole(event.target.value)}}></input></h3>
            <h3>Experience : <input value={experience} onChange={(event)=>{setExperience(event.target.value)}}></input></h3>
            <h3>Deadline : <input value={deadline} onChange={(event)=>{setDeadline(event.target.value)}}></input></h3>
            <h3>Application URl : <input value={url} onChange={(event)=>{setUrl(event.target.value)}}></input></h3>
            <h3>Company URl : <input value={companyUrl} onChange={(event)=>{setCompanyUrl(event.target.value)}}></input></h3>
            <h3>Logo URL : <input value={logo} onChange={(event)=>{setLogo(event.target.value)}}></input></h3>
            <h3>Location : <input value={location} onChange={(event)=>{setLocation(event.target.value)}}></input></h3>
            <h3>Salary : <input value={salary} onChange={(event)=>{setSalary(event.target.value)}}></input></h3>
            <h3>Description : <textarea cols="30" rows="6" value={description} onChange={(event)=>{setDescription(event.target.value)}}></textarea></h3>
            <h3>Requirements : <textarea cols="30" rows="6" value={requirements} onChange={(event)=>{setRequirements(event.target.value)}}></textarea></h3>
          </div>
          
          <div className={classes.right}>
            <button type='submit'>Submit Changes</button>
            <button onClick={triggerUpdateHandler}>Cancel</button>
          </div>
        </form>
      }

    </>

  )
}

export default JobAdmin;